import { useContext, useEffect, useState } from 'react';

import { EventMessage } from '@/common/analytics/gtm/types';
import { getOrCreateAthenaUserIdCookie } from '@/common/athena/checkAndSetAthenaCookie';
import { masonryDefaultImpressionHandler } from '@/common/components/MasonryFeed/MasonryFeedImpressions';
import { MasonryFeeds } from '@/common/components/MasonryFeed/MasonryFeeds';
import { ImpressionsContextProvider } from '@/common/impressions';
import { AuthContext } from '@/contexts/auth/AuthContext';
import {
  createFeedsTitle,
  createMasonryHpFeeds,
  masonryHpMetadata,
} from '@/modules/HomePage/components/HPMasonryFeed/homePageFeeds';
import { useHomepageFeeds } from '@/modules/HomePage/queries.server';

import styles from './HPMasonryFeed.module.scss';

const HPMasonryFeed = () => {
  const { userInfo } = useContext(AuthContext);
  const [athenaUserId, setAthenaUserId] = useState<string | undefined>(undefined);

  const { data: homepageFeed, isStale } = useHomepageFeeds({
    athenaUserId: athenaUserId ?? '',
    enabled: athenaUserId !== undefined,
  });

  useEffect(() => {
    setAthenaUserId(getOrCreateAthenaUserIdCookie());
  }, []);

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>{createFeedsTitle(userInfo?.firstName)}</h2>
      <ImpressionsContextProvider<EventMessage> callback={masonryDefaultImpressionHandler}>
        <MasonryFeeds
          feeds={createMasonryHpFeeds(homepageFeed, userInfo ?? null, !isStale)}
          metadata={masonryHpMetadata}
        />
      </ImpressionsContextProvider>
    </section>
  );
};

export default HPMasonryFeed;
